import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StoreContext } from "shared/context/store-context";
import { AuthContext } from "shared/context/auth-context";
import { getColumnValue } from "shared/util/datagrid";
import { getTodayInTimezone } from "shared/utility/date";
import { ROUTE_TYPES } from "@routebot/constants";

import Layout from "layouts/LayoutMasterDetail";
import DriverItem from "./DriverItem";
import { buildDriverServiceIndex, getDriverServiceNames } from "./driverServices";

const cellLineStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "100%",
  marginBottom: "5px",
  marginTop: "5px",
};

const renderServiceCell = (names) => {
  if (!names?.length) return <div style={cellLineStyle}>-</div>;
  return (
    <div style={{ width: "100%" }}>
      {names.map((name, index) => (
        <div key={index} style={cellLineStyle} title={name}>
          {name}
        </div>
      ))}
    </div>
  );
};

const DriversList = () => {
  const { t } = useTranslation();
  const listName = "main_drivers";
  const itemType = "driverItem";

  const {
    drivers,
    schoolOptions,
    vehicleRoutes,
    bundledRoutes,
    standartPersonelServices,
    shiftPersonelServices,
    DeleteDriver,
    InsertDriver,
    UpdateDriver,
  } = useContext(StoreContext);
  const auth = useContext(AuthContext);

  const pageItems = drivers;

  const todayYmd = getTodayInTimezone(auth?.company?.timezone || auth?.timezone, "yyyy-MM-dd");
  const driverServiceIndex = useMemo(
    () =>
      buildDriverServiceIndex({
        vehicleRoutes,
        bundledRoutes,
        standartPersonelServices,
        shiftPersonelServices,
        todayYmd,
      }),
    [vehicleRoutes, bundledRoutes, standartPersonelServices, shiftPersonelServices, todayYmd],
  );

  let listColumns = [];

  // Eger useSpecialDriver true ve birden fazla okul varsa, school kolonunu goster
  if (auth.company?.useSpecialDriver && schoolOptions?.length > 1) {
    listColumns.push(getColumnValue("school", t("school"), schoolOptions, "school", 350));
  }

  listColumns.push({ field: "name", headerName: t("name"), width: 300 });
  listColumns.push({ field: "phonenumber", headerName: t("phone"), width: 200 });

  listColumns.push({
    field: "routemorning",
    headerName: t("pickUpService"),
    width: 250,
    valueGetter: (params) => {
      const names = getDriverServiceNames(driverServiceIndex, params.row.id, ROUTE_TYPES.PICK_UP);
      return names.length ? names.join(", ") : "-";
    },
    renderCell: (params) =>
      renderServiceCell(getDriverServiceNames(driverServiceIndex, params.row.id, ROUTE_TYPES.PICK_UP)),
  });

  listColumns.push({
    field: "routeevening",
    headerName: t("dropOffService"),
    width: 250,
    valueGetter: (params) => {
      const names = getDriverServiceNames(driverServiceIndex, params.row.id, ROUTE_TYPES.DROP_OFF);
      return names.length ? names.join(", ") : "-";
    },
    renderCell: (params) =>
      renderServiceCell(getDriverServiceNames(driverServiceIndex, params.row.id, ROUTE_TYPES.DROP_OFF)),
  });

  listColumns.push({ field: "plate", headerName: t("plate"), width: 150, hide: true });
  listColumns.push({ field: "email", headerName: t("secondPhone"), width: 250, hide: true });
  listColumns.push({ field: "identity", headerName: t("identity"), width: 150, hide: true });
  listColumns.push({ field: "address", headerName: t("address"), width: 400, hide: true });

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={DriverItem}
      NewItemComponent={DriverItem}
      DeleteItem={DeleteDriver}
      InsertItem={InsertDriver}
      UpdateItem={UpdateDriver}
      hideCreateNewItemWhenSelected={true}
    />
  );
};

export default DriversList;
